const TRANSLATE = {
  title: 'Tokens Públicos',
  newPublicToken: 'Novo token público',
  editPublicToken: 'Editar token público',
  name: 'Nome',
  availableUses: 'Usos disponíveis',
  validUntil: 'Válido até',
  enabled: 'Ativado',
  action: 'Ação',
  maxExecution: 'Máximo de execução',
  expiresAt: 'Vence em',
  usageType: 'Tipo de uso',
  conditions: 'Condições',
  payload: 'Payload',
  remainingUses: 'Uso restante',
  expireDate: 'Data limite',
  publicUrl: 'URL pública',
  calls: '{{count}} chamada',
  calls_plural: '{{count}} chamadas',
  noLimit: 'Sem limite',
  noExpireDate: 'Sem data limite',
  createdAt: 'Data de criação',
  moreDetails: 'Mais detalhes',
  lessDetails: 'Menos detalhes',
  called: 'Chamado',
  error: 'Erro',
  success: 'Sucesso',
  confirmRemove: 'Certeza que deseja remover?'
}

export default TRANSLATE
